<template>
  <div class="page">
    <div class="top" :class="{ train: activityType === '2' }">
      <!-- 搜索框 -->
      <van-search
        v-model="keyword"
        shape="round"
        action-text="搜索"
        show-action
        placeholder="请输入搜索关键词"
        @search="handleQuery(true)"
      >
        <template #action>
          <div @click="handleQuery(true)">搜索</div>
        </template>
      </van-search>
      <!-- 一级分类 -->
      <div class="search-condition">
        <div
          class="item"
          v-for="(item, index) in activityTypeList"
          :key="index"
          @click="handleActivityTypeClick(item)"
          :class="{ 'bg-color': activityType == item.value }"
        >
          {{ item.label }}
        </div>
      </div>
      <!-- 培训分类下的二级菜单-->
      <div class="search-condition type-two" v-show="activityType == '2'">
        <van-radio-group v-model="activityTypeTwo" class="radio-group">
          <van-radio
            icon-size="16px"
            class="radio"
            :name="item.value"
            v-for="item in typeTwo"
            :key="item.value"
            @click="handleActivityTypeTwoClick"
            >{{ item.label }}</van-radio
          >
        </van-radio-group>
      </div>
    </div>
    <!-- 数据渲染部分 -->
    <van-pull-refresh
      class="pull-refresh list-wrap"
      :class="{ train: activityType === '2' }"
      ref="listWrap"
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-list
        :immediate-check="false"
        class="step-wrap"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="handleQuery(false)"
        ref="list"
      >
        <div
          v-for="(item, index) in activityList"
          :key="item.id"
          @click="handleGoDetail(item)"
        >
          <div class="wrap-item" v-show="item.activityType2 != '1'">
            <!-- 左侧 -->
            <div class="left">
              <div class="img-box">
                <img
                  :src="
                    item.activityPicFileUrl
                      ? item.activityPicFileUrl
                      : defaultImg
                  "
                  alt="活动海报"
                />
              </div>
            </div>
            <!-- 右侧 -->
            <div class="right">
              <!-- 标题 -->
              <h2 v-text="item.activityTitle" class="van-ellipsis"></h2>
              <div class="information">
                <!-- 开始时间 -->
                <div class="column" v-hide="item.activityType2 == '2'">
                  <span class="title">开始时间：</span>
                  <span
                    class="message"
                    v-text="item.activityBegintimeStr"
                  ></span>
                </div>
                <!-- 结束时间 -->
                <div class="column" v-hide="item.activityType2 == '2'">
                  <span class="title">结束时间：</span>
                  <span class="message" v-text="item.activityEndtimeStr"></span>
                </div>
                <!-- 每日开放时间 -->
                <div class="column" v-if="item.openingHours">
                  <span class="title">开放时间：</span>
                  <span class="message" v-text="item.openingHours"></span>
                </div>
                <!-- 活动剩余天数 -->
                <div class="column" v-if="item.remainderDays">
                  <span class="title">剩余天数：</span>
                  <span class="message" v-text="item.remainderDays"></span>
                </div>
                <!-- 主讲人 -->
                <div
                  class="column"
                  v-show="item.activityType1 != '1' && item.activityPresenter"
                >
                  <span class="title">主讲人：</span>
                  <span class="message" v-text="item.activityPresenter"></span>
                </div>
                <!-- 活动地点 -->
                <div v-if="item.activityAddress" class="column">
                  <span class="title">活动地点：</span>
                  <span
                    class="message van-ellipsis"
                    v-text="item.activityAddress"
                  ></span>
                </div>
                <!-- 活动简介 -->
                <div v-if="item.activityComments" class="column">
                  <span class="title">活动简介：</span>
                  <span
                    class="message van-ellipsis"
                    v-text="item.activityComments"
                  ></span>
                </div>
                <!-- 会议号 -->
                <div
                  v-if="item.conferenceStr"
                  v-show="
                    item.activityType1 == '2' && item.activityType2 == '2'
                  "
                >
                  <span class="title">线上会议号：</span>
                  <span class="message" v-text="item.conferenceStr"></span>
                </div>
                <div class="column">
                  <span class="title">活动类型：</span>
                  <span class="message" :class="`color1`">
                    <!-- 活动类型为2是培训 -->
                    {{
                      item.activityType1 == "2"
                        ? `${
                            typeOneMap[item.activityType1] +
                            "-" +
                            typeTwoMap[item.activityType2]
                          }`
                        : `${typeOneMap[item.activityType1]}`
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="wrap-item"
            v-show="item.activityType1 == '2' && item.activityType2 == '1'"
          >
            <!-- 左侧时间 -->
            <div class="new-left">
              <div class="left-day">
                <span class="month" v-text="item.timeList[1]"></span>
                <span class="day">/</span>
                <span v-text="item.timeList[2]" class="day"></span>
              </div>
              <div class="year" v-text="item.timeList[0]"></div>
            </div>
            <!-- 右侧数据 -->
            <div
              class="new-right"
              :class="{ border: index < activityList.length - 1 }"
            >
              <h2 v-text="item.activityTitle" class="van-ellipsis"></h2>
              <!-- 标题 -->
              <div class="information">
                <!-- 开始时间 -->
                <div class="column">
                  <span class="title"
                    ><van-icon name="clock-o" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="handleMomentTime(item.activityBegintimeStr)"
                  ></span>
                </div>
                <!-- 活动地点 -->
                <div v-if="item.activityAddress" class="column">
                  <span class="title"
                    ><van-icon name="location-o" color="#1989fa"
                  /></span>
                  <span
                    class="message van-ellipsis"
                    v-text="item.activityAddress"
                  ></span>
                </div>
                <!-- 会议号 -->
                <div v-if="item.conferenceStr" class="column">
                  <span class="title"
                    ><van-icon name="records" color="#1989fa"
                  /></span>
                  <span class="message" v-text="item.conferenceStr"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getSelectList } from "@/api/common";
import { activityListGet } from "@/api/activity";
import {
  STATUS_CODE_OK,
  DICT_T_ACTIVITY_TYPE_ONE,
  DICT_T_ACTIVITY_TYPE_TWO,
} from "@/config";
import { SelectListToMap } from "@/utils";
export default {
  name: "ActivityNewest",
  data() {
    return {
      keyword: "",
      activityTypeList: [], //组件的二级组件
      typeTwo: [], // 二级组件 培训的返回数据二条
      activityType: "",
      activityTypeTwo: "",
      refreshing: false,
      loading: false,
      finished: false,
      activityList: [], //数据渲染
      currentPage: 1,
      pageSize: 10,
      defaultImg: require("@/assets/images/peixun.jpg"),
    };
  },
  computed: {
    // 活动类型1
    typeOneMap() {
      return SelectListToMap(this.activityTypeList);
    },
    // 活动类型2
    typeTwoMap() {
      return SelectListToMap(this.typeTwo);
    },
  },
  async created() {
    await this.handleActivityTypeList();
    await this.handleActivityTypeTwoList();
  },
  methods: {
    // 格式化时间
    handleMomentTime(time) {
      return this.$moment(time)
        .locale("zh-cn")
        .format("YYYY年MMMDo（ddd）ah:mm");
    },
    // 获取活动类型1
    async handleActivityTypeList() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_ONE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.activityTypeList = data.data;
        if (this.activityTypeList.length > 0) {
          this.activityType = this.activityTypeList[0].value;
          this.handleQuery(true);
        }
      }
    },
    // 获取活动类型2
    async handleActivityTypeTwoList() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_TWO,
      });
      if (data.code === STATUS_CODE_OK) {
        this.typeTwo = data.data;
      }
    },
    handleActivityTypeClick(item) {
      this.activityType = item.value;
      if (item.value == "2") {
        this.activityTypeTwo = "1";
      }
      this.handleQuery(true);
    },
    handleActivityTypeTwoClick() {
      this.handleQuery(true);
    },
    // 查询活动列表
    async handleQuery(isRefresh) {
      const that = this;
      if (that.activityType != "2") {
        that.activityTypeTwo = "";
      }
      if (isRefresh) {
        that.currentPage = 1;
        that.finished = false;
        that.loading = true;
      }
      let { data } = await activityListGet({
        keyWord: that.keyword,
        activityType: that.activityType,
        activityType2: that.activityTypeTwo,
        pageNo: that.currentPage,
        pageSize: that.pageSize,
      });
      if (data.code === STATUS_CODE_OK) {
        data.data.result.forEach((item) => {
          item.timeList = item.activityBegintimeStr.split(" ")[0].split("-");
        });
        that.refreshing = false;
        that.loading = false;
        that.finished = data.data.hasMore == "Y" ? false : true;
        that.currentPage++;
        if (isRefresh) {
          that.activityList = data.data.result;
        } else {
          that.activityList = that.activityList.concat(data.data.result);
        }
      }
    },
    // 下拉刷新
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.handleQuery(true);
    },
    // 跳转活动详情页
    handleGoDetail(item) {
      this.$router.push({
        path: "/activityDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .empty {
    background-color: #fff;
  }
  .top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 667;
    background: #fff;
    height: 116px;
    &.train {
      height: 138px;
    }
    .search-condition {
      padding: 15px 20px;
      display: flex;
      .item {
        border: 1px solid #1282f4;
        color: #1282f4;
        text-align: center;
        line-height: 30px;
        border-radius: 30px;
        margin-right: 10px;
        width: 60px;
      }
      .item-two {
        border: 1px solid #1282f4;
        color: #1282f4;
        text-align: center;
        line-height: 30px;
        border-radius: 30px;
        margin-right: 10px;
      }
      .bg-color {
        background-color: #1282f4;
        color: #fff;
      }
    }
    .type-two {
      padding: 0px 20px;
      .radio-group {
        display: flex;
        .radio {
          margin-right: 5px;
        }
      }
    }
  }
  .list-wrap {
    position: fixed;
    top: 116px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    &.train {
      top: 138px;
    }
    .wrap-item {
      margin-bottom: 10px;
      background: #fff;
      padding: 10px 10px;
      display: flex;
      justify-content: space-between;
      .left {
        width: 125px;
        height: 170px;
        flex: none;
        .img-box {
          width: 100%;
          height: 100%;
          text-align: center;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
          }
        }
      }
      .right {
        padding-left: 10px;
        flex: 1;
        h2 {
          font-size: 14px;
          font-weight: normal;
          margin: 10px 0;
          width: 200px;
        }
        .information {
          font-size: 12px;
          color: #969799;
          .column {
            margin-bottom: 5px;
            display: flex;

            .title {
              flex: 0 0 70px;
            }
            .message {
              flex: 1;
              width: 150px;
              &.color1 {
                color: #1989fa;
              }
              &.color2 {
                color: #07c160;
              }
              &.color3 {
                color: #ff976a;
              }
              &.color4 {
                color: #ee0a24;
              }
            }
          }
        }
      }
      .new-left {
        height: 100px;
        flex: 0 0 80px;
        margin-top: 5px;
        text-align: center;
        border-right: 0.5px solid #e8f1f5;
        .left-day {
          width: 80px;
        }
        .month {
          font-weight: bolder;
          font-size: 22px;
        }
        .day {
          color: rgb(111, 111, 111);
          font-size: 12px;
        }
        .year {
          font-size: 12px;
          border-radius: 20px;
          text-align: center;
          width: 40px;
          height: 20px;
          background: #1282f4;
          color: #f7f8fa;
          line-height: 20px;
          margin: 5px auto;
        }
      }
      .new-right {
        flex: 1;
        &.border {
          border-bottom: 0.5px solid #e8f1f5;
        }
        padding-bottom: 10px;
        margin-left: 20px;
        h2 {
          font-size: 18px;
          font-weight: normal;
          margin: 10px 0;
          width: 240px;
        }
        .message {
          margin-left: 5px;
        }
        .information {
          font-size: 12px;
          color: #969799;
          .column {
            padding-top: 5px;
            display: flex;

            .title {
              flex: 0 0 10px;
            }
            .message {
              flex: 1;
              width: 240px;
            }
          }
        }
      }

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
